module.exports = __webpack_public_path__ + "img/FLEX_DT.25dc75b5.png";